const publicApiUrl = process.env.BUN_PUBLIC_YAK_TRAILS_API_URL;
const onlineEnabled = process.env.BUN_PUBLIC_YAK_TRAILS_ONLINE_ENABLED;
const previewIdentityEnabled = process.env.BUN_PUBLIC_YAK_TRAILS_PREVIEW_IDENTITY_ENABLED;

export const YAK_TRAILS_API_URL = typeof publicApiUrl === "string" ? publicApiUrl.trim() : "";
export const YAK_TRAILS_ONLINE_ENABLED = onlineEnabled === "true";
export const YAK_TRAILS_PREVIEW_IDENTITY_ENABLED = previewIdentityEnabled === "true";
